import { Injectable } from "@angular/core";
import { MCCustomFunctionsParams, MCTotalUnitPrice, MCFieldConfigurationService } from "@maslul/common-services";

@Injectable({
    providedIn: 'root'
})
export class TotalUnitPrice extends MCTotalUnitPrice {

    override showTotalUnitsPriceErrorInfoGeneral(isFieldValid: boolean, totalUnitsPriceErrorInfo: string, customFunctionsObj: MCCustomFunctionsParams): void {
        let hideInfo = isFieldValid ? true : false;

        const errorInfoField = customFunctionsObj.formisForm.fields
            .find(x => x.key == 'costDetails')?.fieldGroup
            ?.find(x => x.key == totalUnitsPriceErrorInfo);

        if (errorInfoField && errorInfoField.hide != hideInfo) {
            errorInfoField.hide = hideInfo;
        }
    }

    override isFieldValueValid(fieldToValidate: any, customFunctionsObj: MCCustomFunctionsParams): boolean {
        const fieldConfigurationService = customFunctionsObj.injector.get(MCFieldConfigurationService);
        return fieldConfigurationService.isValueValid(fieldToValidate);
    }
}
